// Module
var code = "<p><strong>{{'upplm.common.placardid' | translateData}}: </strong>{{dataSearch.placardId}}</p>\r\n<p><strong>{{'upplm.common.status' | translateData}}: </strong><span>{{'upplm.anonymousdashboard.canceledon' | translateData}} {{dataSearch.cancelDate}}</span></p>\r\n";
// Exports
module.exports = code;